import { Options, merge } from 'highcharts';
import { baseChartOptions } from './base-chart.options';

/**
 * Configuration for Pie chart type
 * Extends the base chart configuration
 */
export const pieChartOptions: Options = merge({}, baseChartOptions, {
    chart: {
        type: 'pie'
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            borderWidth: 1,
            borderColor: '#ffffff',
            depth: 35,
            dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                style: {
                    textOutline: 'none'
                }
            },
            showInLegend: true
        }
    },
    tooltip: {
        headerFormat: '',
        pointFormat: '<span style="color:{point.color}">\u25CF</span> <b>{point.name}</b>: {point.y} ({point.percentage:.1f}%)<br/>'
    },
    // For pie charts, we typically don't need axes
    xAxis: {
        visible: false
    },
    yAxis: {
        visible: false
    }
} as Options);